import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCategoryBag';
/** Renders an SVG icon. */
const SvgCategoryBag = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.385 15.503a.75.75 0 0 1-.064 1.058L13.13 18.5l2.19 1.939a.75.75 0 0 1-.995 1.122l-2.823-2.5a.75.75 0 0 1 0-1.122l2.823-2.5a.75.75 0 0 1 1.06.064m2.585.967a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l.97-.97-.97-.97a.75.75 0 0 1 0-1.06"
      />
      <path
        fill="currentColor"
        d="m16.604 19.646.792-.792a.5.5 0 0 0 0-.708l-.792-.792a.5.5 0 0 0-.708 0l-.792.792a.5.5 0 0 0 0 .708l.792.792a.5.5 0 0 0 .708 0"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 4a3 3 0 0 0-3 3v2h6V7a3 3 0 0 0-3-3m5 5V7a5 5 0 0 0-10 0v2H9a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V12a3 3 0 0 0-3-3zM9 11a1 1 0 0 0-1 1v12h16V12a1 1 0 0 0-1-1zm15 15H8v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1z"
      />
    </svg>
  );
};
SvgCategoryBag.displayName = displayName;
export default SvgCategoryBag;
